import api from '@/api-v2/shopSign'
import { SIGN_SHOP_STATUS_MAP, BIZOPP_STATUS_OPTIONS, SIGN_PARTY_TYPE_MAP, PARTY_STATUS_MAP } from '@/config-v2/sign/enums'
import { get, reduce, uniq } from 'lodash-es'
// import formConfig from '@/config/sign/config'
// import * as metaData from '@/config/sign/metaData'
import { requestHelper, requestSilence } from '@/common/utils/request'
import { i18n, getBDCountry } from '@/common/utils/i18n'
import { CATEGORY_MAP } from '@/config/sign/enums'
// import {SIGN_SUB_AUDIT_STATUS_LIST} from '@/consts/sign'

const formConfig = async () => await import(/* webpackChunkName: 'sign' */'@/config-v2/sign/config')
// const formConfigBR = async () => await import(/* webpackChunkName: 'sign' */'@/config-BR/sign/config')
// const formConfigJP = async () => await import(/* webpackChunkName: 'sign' */'@/config-JP/sign/config')
// const formConfigCOM = async () => await import(/* webpackChunkName: 'sign' */'@/config-COM/sign/config')

const metaData = async () => await import(/* webpackChunkName: 'sign' */'@/config-v2/sign/metaData')
// const metaDataBR = async () => await import(/* webpackChunkName: 'sign' */'@/config-BR/sign/metaData')
// const metaDataJP = async () => await import(/* webpackChunkName: 'sign' */'@/config-JP/sign/metaData')
// const metaDataCOM = async () => await import(/* webpackChunkName: 'sign' */'@/config-COM/sign/metaData')

const diffStoreConfig = {
  BR: {
    formConfig: formConfig,
    metaData: metaData
  },
  MX: {
    formConfig,
    metaData
  },
  JP: {
    formConfig: formConfig,
    metaData: metaData
  },
  COM: {
    formConfig: formConfig,
    metaData: metaData
  }
}
/**
 * 后端表单数据转换为视图数据
 */

const getCountry = () => {
  const country = getBDCountry()
  // return getBDCountry()
  return diffStoreConfig.hasOwnProperty(country) ? country : 'COM'
}

const revertors = async () => {
  const country = getCountry()
  const config = await diffStoreConfig[country]['formConfig']()
  const meta = await diffStoreConfig[country]['metaData']()
  return config.default.reduce((red, { group }) => {
    let pairs = {}
    if (group) {
      group.forEach(({ name }) => (
        pairs[name] = get(meta, [name, 'revert'])
      ))
    }
    return { ...red, ...pairs }
  }, {})
}
/**
 * 转换审核视图数据，将审核包校验结果按照表单分类维度保存
 * @param {Object} auditInfo 审核实体
 * @returns {Object} 审核状态视图数据
 */
const formatRulesStatus = async (auditInfo) => {
  let res = {}
  let statusPack = get(auditInfo, 'pack', [])
  let pushType = auditInfo.pushType
  const country = getCountry()
  const config = await diffStoreConfig[country]['formConfig']()

  statusPack.forEach(({ tag, reason, status }) => {
    // 2 审核拒绝 保存
    if (status !== 2) return
    let cateNames = tag.map(i => CATEGORY_MAP[i])
    cateNames.forEach(categorys => {
      categorys.forEach(category => {
        let activeKeys = (config.default.find(i => i.category === category) || { group: [] }).group.map(i => i.name)
        let temp = res[category] || {}
        res[category] = Object.assign(temp, {
          active: uniq((temp.active || []).concat(activeKeys)),
          reason: (temp.reason || []).concat(reason)
        })
      })
      if (pushType === 2) {
        categorys.forEach((cate) => {
          const reason = res[cate].reason
          const rSet = new Set(reason)
          res[cate].reason = Array.from(rSet)
        })
      }
    })
  })
  return res
}

export default {
  async setContractor ({ commit, state }, params) {
    let data = []
    try {
      console.log(params)
      data = await api.setContractor(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return data
  },

  async delContractor ({ commit, state }, params) {
    let data = []
    try {
      console.log(params)
      data = await api.delContractor(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return data
  },

  async submitGlobal ({ commit, state }, params) {
    let data = []
    try {
      console.log(params)
      data = await api.submitGlobal(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return data
  },

  async getBindShop ({ commit, state }, params) {
    console.log(params)
    let res = []
    try {
      const { data } = await api.getBindShop(params)
      res = data.map(item => {
        return {...item, complete_status: SIGN_SHOP_STATUS_MAP[item.completeStatus]}
      })
      console.log(data)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res
  },

  async getNameSug ({ commit, state }, params) {
    console.log(params)
    let res = []
    try {
      const { data } = await api.getNameSug(params)
      res = data.shopList.map(item => {
        return {
          ...item,
          associated: +item.contractorId !== 0 ? i18n.gettext('是') : i18n.gettext('否'),
          bizopp_status: (BIZOPP_STATUS_OPTIONS.find(i => i.value === item.status) || {}).label,
          sign_party: SIGN_PARTY_TYPE_MAP[item.type],
          tagType: (BIZOPP_STATUS_OPTIONS.find(i => i.value === item.status) || {}).tagType
        }
      })
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res
  },

  async  fetchSignListOpenCityList ({ commit, state }, params) {
    let result = true
    try {
      result = await api.fetchSignListOpenCityList(params)
      commit('updateSignListOpenCityList', result.data)
    } catch (e) {
      console.error(e)
      return false
    }
    return result
  },

  async getContractorList ({ commit, state }, params) {
    let res = []
    try {
      console.log(params)
      const { data } = await api.getContractorList(params)
      res = data.contractorList.map(item => {
        return {
          ...item,
          sign_party: SIGN_PARTY_TYPE_MAP[item.ka],
          bizopp_status: (PARTY_STATUS_MAP.find(i => i.value === item.status) || {}).label
        }
      })
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res
  },

  async submitSignDetail ({ commit, dispatch, state }, { shopId }) {
    try {
      const contractorId = state.signForm.shopInfo.contractorId
      // 检查是否提交过签约主体信息
      // if (!checkShopInfo(state, dispatch)) return
      const res = await requestHelper(api.submitSignDetail, { contractorId })
      if (res) {
        dispatch('message', i18n.gettext('提交成功！'), { root: true })
        dispatch('goto', { name: 'relationShop', query: { shopId: shopId } }, { root: true })
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },

  async updateSignInfo ({ dispatch, state, commit }, { shopId, data, isShopInfo }) {
    // 检查是否提交过签约主体信息, 或当前为签约主体信息更新
    // if (!(isShopInfo || checkShopInfo(state, dispatch))) return
    const res = await requestHelper(api.saveSignDetail, data)
    if (res) {
      // 清理页面缓存
      // commit('shopDetail/clearCache', { shopId }, { root: true })
      dispatch('goto', { name: 'shopSign', params: { type: '0', id: shopId }, method: 'replace' }, { root: true })
    }
  },

  async getSignInfo ({ commit, dispatch }, payload) {
    const { queryId } = payload
    dispatch('showLoading', null, { root: true })
    const res = await requestSilence(api.getSignDetail, payload)
    if (res) {
      const contractorId = get(res, 'shopGlobal.contractorId')
      if (+contractorId) {
        await dispatch('getContractInfo', { contractorId, shopId: queryId })
      }
      await dispatch('revertBackendData', { res: res, queryId: queryId})
      commit('pickProcessStatus', { processType: 'shopStatus', status: get(res, 'shopGlobal.status') })
      commit('pickSignType', get(res, 'contractGlobal.signType'))
      commit('setContractGlobalStatus', get(res, 'contractGlobal'))
    }
    dispatch('hideLoading', null, { root: true })
  },

  async getCommonConfig ({ commit, dispatch }, payload) {
    const res = await requestSilence(api.getCommonConfig, payload)
    commit('updateTaxSourceTypeConfig', {
      taxSourceType: res || []
    })
    return res
  },

  async getContractInfo ({ commit, dispatch }, payload) {
    const { contractorId, shopId } = payload
    const auditContract = await requestSilence(api.getContractInfo, {
      queryId: contractorId,
      fields: 'auditGlobal',
      source: 'contractor'
    })
    // const id = get(auditContract, 'auditGlobal.shop[0].shopId')
    let auditShop = {}
    if (shopId) {
      auditShop = await requestSilence(api.getSignAudit, {
        queryId: shopId,
        fields: 'auditGlobal',
        source: 'shop'
      })
    }
    const getMerged = (pack, keys) => {
      /** 递归每个节点拼合merged参数, 兼容中间少一个key的情况 */
      if (!Array.isArray(pack)) {
        pack = []
      }
      const recursive = (keys, parents = []) => {
        const key = keys[0]
        return (target, item) => {
          if (key != null) {
            const arr = Array.isArray(item[key]) ? item[key] : parents
            return target.concat(arr.reduce(recursive(keys.slice(1), arr), []))
          }
          return target.concat([item])
        }
      }
      return pack.reduce(recursive(keys, pack), [])
    }
    // 与产品确认，此处审核（商铺审核，合同审核）要么都来自于starfall。要么来自通用审核
    const pushType = get(auditContract, 'auditGlobal.pushType', 1)
    const auditInfo = get(auditContract, 'auditGlobal', {})
    const shopList = auditInfo.shop || []
    let merged = []
    if (pushType === 1) {
      merged = auditInfo.pack || []
      if (auditShop) {
        const pack = get(auditShop, 'auditGlobal.pack', [])
        merged = merged.concat(pack)
      }
    } else {
      merged = getMerged(auditInfo.pack, ['processList', 'nodeDetailList', 'externalList'])
      if (auditShop) {
        const pack = get(auditShop, 'auditGlobal.pack', [])
        merged = merged.concat(getMerged(pack, ['processList', 'nodeDetailList', 'externalList']))
      }
      function getStatus (status) {
        switch (status) {
          case 0:
            return 1
          case 1:
            return 3
          case 2:
            return 2
          default:
            return 0
        }
      }
      merged = merged.map((item) => {
        return {
          ...item,
          status: getStatus(item.resultStatus)
        }
      })
    }
    auditInfo.pack = merged
    auditInfo.pushType = pushType
    commit('updateAuditInfo', { auditInfo, shopList, shopId })
    const auditStatus = await formatRulesStatus(auditInfo)
    commit('updateAuditStatus', auditStatus)
  },

  /**
   * 后端表单数据转换为视图数据
   */
  async revertBackendData ({ commit, state }, payload) {
    const revertor = await revertors()
    const signForm = reduce(
      revertor,
      (red, revert, key) => {
        return { ...red, [key]: revert(payload.res) }
      },
      {}
    )
    let stashRes = await requestSilence(api.getCommonApplyBaseInfo, {
      shopId: payload.queryId,
      commonApplyType: 104
    })
    const { name, addr, lat, lng } = stashRes || {}
    signForm.shopInfo = {
      ...signForm.shopInfo,
      name: name,
      addr: addr,
      lat: lat,
      lng: lng
    }
    commit('setSignInfo', { path: 'signForm', data: signForm })
  },

  resetAudit ({ commit, state }) {
    commit('resetAudit')
  }
}
